<template>
  <div>
    <b-card class="m-3" no-body>
      <template #header>
        <h6 class="mb-0 text-center titulo-sagres font-weight-bold">
          Relatório Índices estratégicos por município
        </h6>
      </template>
      <b-form v-if="!blockForm" class="m-2" @submit.stop.prevent="gerarRelatorio">
        <b-row>
          <b-col cols="12" xl="2">
            <b-form-group id="input-group-exercicio" label="Exercício *" label-for="input-exercicio"
              label-class="text-left">
              <b-form-select id="input-exercicio" v-model="filtros.exercicio" :options="exercicios"
                :disabled="desabilitarIepm || loading"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="12" xl="4">
            <b-form-group id="input-group-municipio" label="Município" label-for="input-municipio"
              label-class="text-left">
              <span style="float: left"><strong>{{ nomeMunicipio }}</strong></span>
            </b-form-group>
          </b-col>
          <b-col cols="12" xl="6" class="d-flex align-items-center justify-content-end">
            <b-button class="mr-2" size="md" variant="secondary" type="submit" :disabled="desabilitarIepm || loading">
              <font-awesome-icon icon="file-alt" class="mr-2" />
              Gerar Relatório
            </b-button>
          </b-col>
        </b-row>
      </b-form>
      <div v-else class="text-center">
        <b-spinner label="Carregando..."></b-spinner>
      </div>
    </b-card>
    <div v-if="loading" class="text-center">
      <b-spinner label="Carregando..."></b-spinner>
    </div>
    <pdf-viewer v-if="!loading && pdfData" :data="pdfData" :filename="filename" />
  </div>
</template>

<script>
import reportService from '@/services/reportService'
import PdfViewer from "@/components/PdfViewer.vue"
import { UtilsTS } from '@/utilsts'
import { FiltrosGestao } from '@/types/relatorios/filtros-gestao'

export default {
  mixins: [UtilsTS],
  components: {
    PdfViewer
  },
  data() {
    return {
      filename: null,
      pdfData: null,
      desabilitarIepm: false,
      exercicios: [],
      filtros: {
        exercicio: null,
        municipio: null,
      },
      nomeMunicipio: null,
      loading: false,
      blockForm: false,
    }
  },
  methods: {
    async prepararIepm() {
      this.blockForm = true
      const prepararIepmResponse = await reportService.prepararIepm()
      if (prepararIepmResponse && prepararIepmResponse.status == 200) {
        this.desabilitarIepm = prepararIepmResponse.data.desabilitarIEpM
        if (!this.desabilitarIepm) {
          this.exercicios = prepararIepmResponse.data.exercicios.map(e => {
            return { value: e, text: e }
          })
          this.nomeMunicipio = prepararIepmResponse.data.nomeMunicipio
          this.filtros.exercicio = this.exercicios[0].value
          this.filtros.municipio = prepararIepmResponse.data.nomeMunicipio
        }
        else {
          this.$toast.error('erro ao preparar relatório')
        }
      }
      else {
        this.$toast.error('erro ao preparar relatório')
      }
      this.blockForm = false
    },

    async gerarRelatorio() {
      try {
        this.pdfData = null;
        this.loading = true;
        const ftr = new FiltrosGestao()
        ftr.exercicio = this.filtros.exercicio
        const response = await reportService.getRelatorioGestao('IEPM', ftr)
        this.filename = "IndicesEstrategicos_" + this.filtros.exercicio + "_" + this.nomeMunicipio;
        const blob = this.base64ToPdf(response.ArquivoPdf)
        const objectUrl = URL.createObjectURL(blob)
        this.pdfData = objectUrl;
      } catch (e) {
        this.tratarError(e)
      } finally {
        this.loading = false;
      }
    }
  },

  async mounted() {
    await this.prepararIepm()
  }

}
</script>

<style>
#cardFiltros {
  text-align: left;
  margin: 20px auto !important;
  width: 95%;
}
</style>